import { combineReducers } from "redux";
import { modelReducer } from "react-redux-form";
import { localeReducer as locale } from "react-localize-redux";
import { Reducers as gridReducers } from "react-redux-grid";

import { authentication } from "./authentication.reducer";
import { settings } from "./settings.reducer";
import { files } from "./files.reducer";
import { documents } from "./documents.reducer";
import { reports } from "./reports.reducer";
import { dashboard } from "./dashboard.reducer";
import { config } from "./config.reducer";
import { alert } from "./alert.reducer";
import { msg } from "./msg.reducer";
import { loaderMask } from "./loaderMask.reducer";
import { flows } from "./flows.reducer";
import { home } from "./home.reducer";
import { smartSearch } from "./smartSearch.reducer";
import {
  initConfigReportsSearchFormState,
  initDashboardSearchFormState,
  initDocsSearchFormState,
  initExecReportsSearchFormState,
  initFilesSearchFormState,
  initHomeSearchFormState,
} from "../../utils/constants";

const user = JSON.parse(localStorage.getItem("PortalUserSettings"));
const subUser = JSON.parse(localStorage.getItem("SubUserSettings"));

const currentUser = subUser || user || {};
const defaultSize = currentUser.pageItemCount || 20;

const rootReducer = combineReducers({
  ...gridReducers,
  authentication,
  settings,
  files,
  documents,
  reports,
  dashboard,
  flows,
  config,
  alert,
  msg,
  home,
  smartSearch,
  loaderMask,
  fileSearch: modelReducer("fileSearch", {
    ...initFilesSearchFormState,
    Size: defaultSize,
  }),
  docSearch: modelReducer("docSearch", {
    ...initDocsSearchFormState,
    Size: defaultSize,
  }),
  execReportSearch: modelReducer("execReportSearch", {
    ...initExecReportsSearchFormState,
    Size: defaultSize,
  }),
  configReportSearch: modelReducer("configReportSearch", {
    ...initConfigReportsSearchFormState,
    Size: defaultSize,
  }),
  dashboardSearch: modelReducer(
    "dashboardSearch",
    initDashboardSearchFormState
  ),
  homeSearch: modelReducer("homeSearch", initHomeSearchFormState),

  smartSearchParams: modelReducer("smartSearchParams", {
    ...initHomeSearchFormState,
  }),
  locale,
});

export default rootReducer;
